import { render, staticRenderFns } from "./NotificationAuthorization.vue?vue&type=template&id=79b0deea&scoped=true&"
import script from "./NotificationAuthorization.vue?vue&type=script&lang=js&"
export * from "./NotificationAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b0deea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
